import styled from 'styled-components';

const BgImgWrapper = styled.div`
  background-image: url(${(props) => props.bgUrl});
  background-position: center right;
  background-repeat: ${(props) => (props.repeatY ? 'repeat-y' : 'no-repeat')};
  opacity: 1;
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
`;

export { BgImgWrapper };
